import React from 'react';

const Error= () => {
	return (
		<div>
			The Url You Requested is not Found
		</div>
	);
}
export default Error;